import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent {

  public constructor(private titleService: Title, private meta: Meta) {
    this.titleService.setTitle('M|Catering - Michigan Catering Gallery')
    this.meta.updateTag({
      name: 'description',
      content: 'Take a look at an exquisite selection of Michigan Catering’s fresh, authentic foods. From savory entrees to sensational sweets, our award-winning chefs take pride in preparing every bite.'
    });
    this.meta.updateTag({
      name: 'og:title',
      content: 'Michigan Catering Photo Gallery'
    });
    this.meta.updateTag({
      name: 'og:description',
      content: 'Take a look at an exquisite selection of Michigan Catering’s fresh, authentic foods. From savory entrees to sensational sweets, our award-winning chefs take pride in preparing every bite.'
    });
  }

}
